// React
import React, { useState, useEffect, useRef, useCallback } from 'react'

// Custom libraries
import * as Yup from 'yup';
import moment from 'moment';
import {takeUntil} from 'rxjs';
import { useFormik } from 'formik';
import 'react-toastify/dist/ReactToastify.css'
import { ToastContainer } from 'react-toastify'
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { Card, Col, Container, Form, Input, FormFeedback, Spinner } from 'reactstrap';

// actions
import { getKinds } from '../../store/catalogs/Kinds/actions'
import { getLabTypes } from '../../store/catalogs/LabTypes/actions'
import { getLocations } from '../../store/catalogs/Locations/actions'
import { getLabRequest } from '../../store/labCitec/labRequest/actions'
import { getOperatives, getTechAdvisors } from '../../store/catalogs/Users/actions'
import { addNewNotificationManager } from '../../store/notifications/managers/actions'
import { getLabRequestAssignments } from '../../store/labCitec/labRequestAssignments/actions'

// Miscellaneous Component
import Table1 from '../../components/Common/TableContainer'
import Breadcrumb from '../../components/Common/Breadcrumb'
import { BackButton } from '../../components/Common/BackButton'
import { notificationValidationStatus, validationProcess } from '../../constants/holcim'

// Custom functionalities
import { useNotificationSelectedUsers } from './Hooks';
import {SharedNotificationService} from './Services';
import { ProcessNotificationReactiveModal } from './ProcessNotificationReactiveModal';

import { BaseSelectComponent, BaseCustomButton } from '../../shared';

export const ProcessNotification = (props) => {
  // External services and custom hooks
  const {
    usersChecked,
    onDelete,
    resetUsersArr,
    retrieveUserIdsFromParams,
    setUserArraySubscriber,
  } = useNotificationSelectedUsers()
  const sharedNotificationService = new SharedNotificationService();

  const onDeleteRef = useRef(onDelete);
  useEffect(() => {
    onDeleteRef.current = onDelete;
  }, [onDelete]);

  const stableOnDelete = useCallback((row) => {
    onDeleteRef.current(row);
  }, []);

  // * Redux
  const dispatch = useDispatch();
  const requestId = props.match.params.id;

  useEffect(() => {
      dispatch(getKinds("?limit=20&page=0"))
      dispatch(getLabRequest(`/${requestId}`))
      dispatch(getLocations(`?limit=100&page=0`))
      dispatch(getLabTypes(`?limit=100&page=0`))
      dispatch(getTechAdvisors(`?limit=20&page=0&userType=Asesor Técnico&recordStatus=enable`))
      dispatch(getOperatives(`?limit=20&page=0&userType=Operativo&recordStatus=enable`))
      dispatch(getLabRequestAssignments(`?limit=100&page=&labRequest=${requestId}`))
  }, [dispatch, requestId])

  const {
    loading,
    operatives,
    labRequest,
    mainLoading,
    usersLoading,
    techAdvisors,
    totalOperatives,
    totalTechAdvisors,
    currentPageOperatives,
    currentPageTechAdvisors,
    labRequestAssignments
   } = useSelector(state => ({
      loading: state.kinds.loading,
      labRequest: state.labRequestReducer.labRequest,
      mainLoading: state.notificationManagersReducer.loading,
      usersLoading: state.usersReducer.loading,
      operatives: state.usersReducer.operatives,
      totalOperatives: state.usersReducer.totalOperatives,
      currentPageOperatives: state.usersReducer.currentPageOperatives,
      techAdvisors: state.usersReducer.techAdvisors,
      totalTechAdvisors: state.usersReducer.totalTechAdvisors,
      currentPageTechAdvisors: state.usersReducer.currentPageTechAdvisors,
      labRequestAssignments: state.labRequestAssignmentReducer.labRequestAssignments,
  }), shallowEqual);
  // * Redux fin

  useEffect(() => {
    if (labRequestAssignments && sharedNotificationService.lastLoadedRequestId !== requestId) {
      const preloadedUsers = labRequestAssignments.map(assignment => {
        if (!assignment.user) return null;
        return {
          id: assignment.user.id,
          name: `${assignment.user.name ?? ''} ${assignment.user.surname ?? ''}`.trim(),
          role: assignment.user.role ?? '',
          laboratoryType: assignment.laboratoryType ? { name: assignment.laboratoryType.name } : null,
          location: assignment.location ? { name: assignment.location.name } : null,
        };
      }).filter(Boolean);

      setUserArraySubscriber(preloadedUsers);
      sharedNotificationService.lastLoadedRequestId = requestId;
    }
  }, [labRequestAssignments, requestId]);

  const obj = JSON.parse(localStorage.getItem("authUser"))
  const [userId] = useState(obj.id);
  const [userName] = useState(`${obj.name} ${obj.surname}`);

  // Modal Variables
  const [isUpdate, setIsUpdate] = useState(false);
  const [showModal1, setShowModal1] = useState(false);
  const [searchData] = useState('');

  useEffect(() => {
      dispatch(getKinds(`?limit=20&page=0&search=${searchData}`))
  }, [dispatch, searchData])

  //Data for the header of the table (Backend)
  const columns = React.useMemo(
      () => [
          {
              Header: 'Nombre de Usuario',
              width: '30%',
              Cell: ({ row }) => (
              <div className='text-primary'>{row.original.name ?? '-'}</div>
              ),
          },
          {
              Header: 'Tipo de Laboratorio',
              width: '13%',
              Cell: ({ row }) => (
              <div className='text-primary'>{row.original.laboratoryType?.name ?? '-'}</div>
              ),
          },
          {
              Header: 'Rol de Usuario',
              accessor: 'role',
              width: '14%',
          },
          {
              Header: 'Sede',
              width: '13%',
              Cell: ({ row }) => (
              <div className='text-primary'>{row.original.location?.name ?? '-'}</div>
              ),
          },
          {
              width: '10%',
              Header: "Acciones",
              Cell: ({ row }) => (
                  <div className="page-title-box d-flex align-items-center justify-content-center">
                        <BaseCustomButton
                            color="secondary"
                            outline={true}
                            className="text-danger rounded-3 p-1 ms-2"
                            icon="mdi-18px mdi-delete p-3 ms-2"
                            onClick={() => stableOnDelete(row.original)}
                        />

                  </div>
              ),
          },
      ],
      [stableOnDelete]
  )

  const modalClose = () => {
      setIsUpdate(false)
      dispatch(getOperatives(`?limit=20&page=0&userType=Operativo`))
      dispatch(getTechAdvisors(`?limit=20&page=0&userType=Asesor Técnico`))
  }

  const onSearchOperatives = (value) => {
      dispatch(getOperatives(`?limit=20&page=0&userType=Operativo&search=${value}`))
  }

  const onSearchTechAdvisors = (value) => {
      dispatch(getTechAdvisors(`?limit=20&page=0&userType=Asesor Técnico&search=${value}`))
  }

  const getPaginationTech = (params) => {
      dispatch(getTechAdvisors(`${params}&userType=Asesor Técnico`))
  }

  const getPaginationOp = (params) => {
      dispatch(getOperatives(`${params}&userType=Operativo`))
  }

  const validation = useFormik({
      // enableReinitialize : use this flag when initial values needs to be changed
      enableReinitialize: true,
      initialValues: {
          labRequest: labRequest.code ?? '-',
          user: userName,
          datedAt: (moment().format('YYYY-MM-DD')),
          validateProcess: props?.location?.state?.validateProcess ?? '',
          validationStatus: props?.location?.state?.validationStatus ?? '',
          description: '',
      },
      validationSchema: Yup.object({
        labRequest: Yup.string().required("Ingrese el código del reporte final"),
        validateProcess: Yup.string().required("Proceso a Validar es un campo obligatorio"),
        validationStatus: Yup.string().required("Estatus de validación es un campo obligatorio"),
        description: Yup.string().required("Ingrese la descripción"),
      }),
      onSubmit: (values, { resetForm }) => {
        const { labRequest:lab, user ,...rest } = values
        const postValue= {
            ...rest,
            labRequest: labRequest.id,
            userNotifier: userId,
            notificationResponsibles: retrieveUserIdsFromParams(usersChecked)
        };

        dispatch(addNewNotificationManager(postValue));
        resetForm();
        resetUsersArr();
      }
  });

  const submitForm = () =>{
      console.log("Valores de Formik antes de enviar:", validation.values);
      console.log("Errores de validación de Formik:", validation.errors);
      validation.submitForm()
  }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid className="" >
                    <Col className="col-12" style={{ padding: 20 }}>
                        <Card className='' style={{ padding: 50 }}>
                            <Breadcrumb breadcrumbItem1='labCitec' breadcrumbItem2='processNotification' />

                            {
                                mainLoading ?
                                <div className="text-center py-5">
                                    <Spinner
                                        color="primary"
                                    >
                                    </Spinner>
                                    <div className="row-center mt-2">
                                    {' '}Cargando...
                                    </div>
                                </div>
                                :
                                <Card className='' style={{ padding: 20 }}>
                                    <div className='d-flex justify-content-between'>
                                    <h5 className='text-primary'>Notificación de Validación de Procesos</h5> 
                                    <BackButton props={props} />
                                    </div>
                                    <h6 className='text-success'>Datos Generales</h6>

                                    <div className='row'>
                                        <div className='col-5'>
                                            <Form
                                                className="form-vertical mt-3 mb-1"
                                                onSubmit={(e) => {
                                                    e.preventDefault();
                                                    validation.handleSubmit();
                                                    return false;
                                                }}
                                            >
                                                <div className="col-3 col-md-12 mb-3">
                                                    <div className="mb-1 px-2">
                                                        <label className='text-primary'>ID Solicitud</label>
                                                        <Input
                                                            disabled={true}
                                                            name="labRequest"
                                                            className="form-control text-primary"
                                                            placeholder="ID de solicitud"
                                                            type="text"
                                                            onChange={validation.handleChange}
                                                            onBlur={validation.handleBlur}
                                                            value={validation.values.labRequest || ""}
                                                            invalid={
                                                                !!(validation.touched.labRequest && validation.errors.labRequest)
                                                            }
                                                        />
                                                        {validation.touched.labRequest && validation.errors.labRequest ? (
                                                            <FormFeedback type="invalid">{validation.errors.labRequest}</FormFeedback>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className="col-3 col-md-12 mb-3">
                                                    <div className="mb-1 px-2">
                                                        <label className='text-primary'>Usuario que notifica</label>
                                                        <Input
                                                            disabled={true}
                                                            name="user"
                                                            className="form-control text-primary"
                                                            placeholder="Usuario"
                                                            type="text"
                                                            onChange={validation.handleChange}
                                                            onBlur={validation.handleBlur}
                                                            value={validation.values.user || ""}
                                                            invalid={
                                                                !!(validation.touched.user && validation.errors.user)
                                                            }
                                                        />
                                                        {validation.touched.user && validation.errors.user ? (
                                                            <FormFeedback type="invalid">{validation.errors.user}</FormFeedback>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className='col-3 col-md-12 mb-3'>
                                                    <div className="mb-1 px-2">
                                                        <label className='text-primary ml-1'>Fecha de Notificación</label>
                                                        <div className='w-100 me-3'>
                                                            <Input
                                                            required
                                                            disabled={true}
                                                            name="datedAt"
                                                            className="form-control rounded-3 text-primary"
                                                            type='date'
                                                            value={validation.values.datedAt}
                                                            onChange={validation.handleChange}
                                                            onBlur={validation.handleBlur}
                                                            invalid={
                                                                !!(validation.touched.datedAt && validation.errors.datedAt)
                                                            }
                                                            />
                                                            {validation.touched.datedAt && validation.errors.datedAt ? (
                                                            <FormFeedback type="invalid">{validation.errors.datedAt}</FormFeedback>
                                                        ) : null}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-3 col-md-12 mt-3">
                                                    <div className="mb-1 px-2">
                                                        <label className='text-primary'>Proceso a Validar</label>
                                                        <BaseSelectComponent
                                                            name="validateProcess"
                                                            options={validationProcess.map(dir => ({ value: dir.id, label: dir.value }))}
                                                            value={validation.values.validateProcess}
                                                            onChangeAsObject={true}
                                                            onChange={(selectedOption) => validation.setFieldValue("validateProcess", selectedOption?.value || "")}
                                                            placeholder="Proceso a validar"
                                                            error={validation.errors.validateProcess}
                                                            touched={validation.errors.validateProcess}
                                                            status={validation.errors.validateProcess ? 'error' : ''}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-3 col-md-12 mt-3">
                                                    <div className="mb-1 px-2">
                                                        <label className='text-primary'>Estatus de Validación</label>
                                                        <BaseSelectComponent
                                                            name="validationStatus"
                                                            options={notificationValidationStatus.map(dir => ({ value: dir.id, label: dir.value }))}
                                                            value={validation.values.validationStatus}
                                                            onChangeAsObject={true}
                                                            onChange={(selectedOption) => validation.setFieldValue("validationStatus", selectedOption?.value || "")}
                                                            placeholder="Estatus"
                                                            error={validation.errors.validationStatus}
                                                            touched={validation.errors.validationStatus}
                                                            status={validation.errors.validationStatus ? 'error' : ''}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-3 col-md-12 mt-3">
                                                    <div className="mb-1 px-2">
                                                        <label className='text-primary'>Descripción</label>
                                                        <Input
                                                            required
                                                            name="description"
                                                            className="form-control rounded-3 text-primary"
                                                            type='textarea'
                                                            value={validation.values.description}
                                                            onChange={validation.handleChange}
                                                            onBlur={validation.handleBlur}
                                                            invalid={
                                                                !!(validation.touched.description && validation.errors.description)
                                                            }
                                                            />
                                                            {validation.touched.description && validation.errors.description ? (
                                                            <FormFeedback type="invalid">{validation.errors.description}</FormFeedback>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </Form>
                                        </div>
                                        <div className='col-7'>
                                            <div className="d-flex justify-content-end">
                                                <BaseCustomButton
                                                    color='primary'
                                                    className='rounded-3 me-2'
                                                    onClick={() => { setShowModal1(!showModal1) }}
                                                    label='Agregar Usuarios'
                                                    outline={true}
                                                    icon="mdi mdi-plus-circle-outline me-1"
                                                />
                                            </div>
                                            <div className='row mx-2'>
                                                <Table1
                                                total={1}
                                                currentPage={0}
                                                loading={loading}
                                                data={usersChecked?.length > 0 ? [...usersChecked] : []}
                                                isAddTableBorderStrap columns={columns}
                                                />
                                            </div>
                                            <div className='mt-5'>
                                                <div className="page-title-box d-flex justify-content-end">
                                                    <BaseCustomButton
                                                        color='success'
                                                        className='rounded-3 me-2'
                                                        onClick={submitForm}
                                                        label='Guardar'
                                                        outline={true}
                                                        icon="mdi mdi-content-save me-1"
                                                    />
                                                    <BaseCustomButton
                                                        color='danger'
                                                        className='rounded-3 me-3'
                                                        onClick={() => {props.history.goBack()}}
                                                        label='Cancelar'
                                                        outline={true}
                                                        icon="mdi mdi-close-circle me-1"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <ProcessNotificationReactiveModal
                                    props={props}
                                    users={operatives}
                                    loading={usersLoading}
                                    showModal={showModal1}
                                    advisers={techAdvisors}
                                    modalClose={modalClose}
                                    total={totalOperatives}
                                    setShowModal={setShowModal1}
                                    modalHeader='Asignar Usuarios'
                                    adviserTotal={totalTechAdvisors}
                                    getPaginationOp={getPaginationOp}
                                    currentPage={currentPageOperatives}
                                    getPaginationTech={getPaginationTech}
                                    onSearchOperatives={onSearchOperatives}
                                    onSearchTechAdvisors={onSearchTechAdvisors}
                                    adviserCurrentPage={currentPageTechAdvisors}
                                    />
                                </Card>
                            }
                            <br />
                            <br />
                        </Card>
                    </Col>
                    <ToastContainer autoClose={2000} newestOnTop={true} />
                </Container>
            </div>
        </React.Fragment>
    )
}
